
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaiairporttopuneinnovacrystacabs() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Innova Crysta Cabs',
        heading: 'Meghana Cab : Mumbai Airport to Pune Innova Crysta Cabs',
        headingDescription: 'Meghana Cab offers Mumbai Airport to Pune Innova Crysta Cabs, providing a premium and stress‑free transfer service between Mumbai International Airport and Pune. Perfect for business travelers, families, and VIP guests, our Innova Crysta vehicles feature plush leather interiors, generous legroom, and ample luggage space—ideal for long-distance airport journeys. Benefit from flight–aware chauffeurs who monitor your landing time for timely pickups, seamless door‑to‑door service, transparent fixed pricing, and GPS tracking for your peace of mind. With 24/7 customer support and flexible payment options, your ride from Mumbai Airport to Pune is guaranteed to be smooth, safe, and comfortable. Book your Mumbai Airport to Pune Innova Crysta Cab with Meghana Cab for a premium travel experience from touchdown to your destination.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic 18th-century fortification built in 1732 by the Peshwas of the Maratha Empire. Once a grand seven-story palace complex, it was the seat of power for the Marathas until it was largely destroyed by a fire in 1828. Today, its majestic stone walls, Delhi Gate, fountains, garden courtyards, and haunting legends attract history lovers and curious travelers alike. The light-and-sound show held in the evenings vividly narrates the glory, politics, and drama of the Maratha reign, offering an immersive dive into Pune's regal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892 by Sultan Aga Khan III, this palatial structure played a significant role in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai following the launch of the Quit India Movement. Today, the palace stands as a serene museum preserving personal artifacts of the Gandhis, including letters, utensils, and photographs. Its lush gardens and Italian-style arches make it a peaceful, contemplative retreat and a symbol of national pride."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a cliff about 1,317 meters above sea level, Sinhagad Fort is a popular trekking destination and a monument of immense historical importance. It was the site of the legendary Battle of Sinhagad in 1670, where Tanaji Malusare sacrificed his life for the Maratha Empire. The fort offers sweeping views of the Sahyadri hills, rustic village-style food stalls serving pithla-bhakri, and remains of old ramparts, watchtowers, and gates. It’s a must-visit for adventure seekers, history buffs, and those looking for a scenic monsoon getaway."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the leafy Koregaon Park area, the Osho Ashram is a globally renowned spiritual and wellness retreat. Spanning 28 acres of landscaped gardens, modern Zen architecture, and marble meditation halls, the center offers unique active meditations, wellness therapies, and spiritual workshops. Attracting thousands of visitors from around the world, it blends luxury with mindfulness, offering a tranquil escape from the city's chaos. Whether you're seeking inner peace, silence, or global community interaction, Osho's Pune campus is a one-of-a-kind experience."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the highest natural points in Pune, offering panoramic views of the city skyline and surrounding hills. A flight of 103 stone steps leads to the Peshwa-era Parvati Temple, dedicated to Goddess Parvati, along with shrines of Vishnu, Ganesha, and Kartikeya. The hilltop also houses a small museum showcasing Maratha artifacts. This peaceful locale is a favorite among morning joggers, photographers, and devotees seeking both spiritual calm and a bird’s-eye view of Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum is a treasure trove of Indian decorative arts and everyday objects from the 17th to 20th centuries. Curated by Dr. Dinkar Kelkar in memory of his son, the museum houses over 20,000 artifacts, including musical instruments, ancient weapons, wooden doors, utensils, and intricate sculptures. The highlight is the recreated ‘Mastani Mahal’, reflecting royal Maratha grandeur. Its interactive galleries and multilingual audio tours make it a cultural gem for anyone interested in India’s rich domestic and artisan history."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "This highly revered Ganesh temple in Budhwar Peth is over 125 years old and attracts lakhs of devotees, especially during Ganesh Chaturthi. The temple houses a 7.5-foot-tall, gold-adorned idol of Lord Ganesha, surrounded by ornate silver and gold decorations. It was built by sweet merchant Dagdusheth Halwai and is known not just for its spiritual ambiance, but also for its charity work and cultural events. Its accessibility and aura make it a daily stop for Puneites and tourists alike."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An ancient 8th-century rock-cut cave temple carved out of a single basalt rock, Pataleshwar is dedicated to Lord Shiva and features a sanctum sanctorum with a Shiva linga, a circular Nandi mandapa, and intricately carved columns. Tucked away on Jangli Maharaj Road amidst modern buildings, the temple is a peaceful and surprisingly well-preserved example of Indian monolithic architecture. It’s a serene spot for meditation and a must-visit for heritage lovers."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Shinde Chhatri is a royal memorial dedicated to Mahadji Shinde, a great Maratha commander in the 18th century. Located in Wanowrie, the monument is a blend of Rajasthani and Indo-Saracenic architecture, adorned with stained-glass windows, ornate pillars, and carved domes. The tranquil complex also houses a temple and the warrior’s samadhi. Its lesser-known status makes it a peaceful place to explore Pune’s forgotten royal heritage."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning over 130 acres, this modern zoological park in Katraj houses a diverse range of animals including white tigers, elephants, sloth bears, reptiles, and exotic birds. It also includes a well-maintained snake park with educational exhibits. The adjoining Katraj Lake adds scenic value, and the park's clean pathways and greenery make it a favorite for families and children. Conservation programs and animal adoption initiatives are also part of the park’s ecological mission."
  }
],

"services": [
  {
    "name": "Mumbai Airport to Pune Innova Crysta Cab Booking",
    "description": "Book your Mumbai Airport to Pune Innova Crysta cab easily for a comfortable and timely transfer. Ideal for families, business travelers, and tourists, our service offers spacious seating, ample luggage space, and professional chauffeurs ensuring a smooth journey."
  },
  {
    "name": "One Way Innova Crysta Mumbai Airport to Pune",
    "description": "Travel hassle-free with our one-way Innova Crysta taxi service from Mumbai Airport to Pune. Perfect for solo travelers or quick trips, this service guarantees punctual pickups, climate-controlled interiors, and a relaxing ride."
  },
  {
    "name": "Round Trip Mumbai Airport Pune Innova Crysta",
    "description": "Plan your round trip from Mumbai Airport to Pune with our reliable Innova Crysta cab service. Enjoy flexible scheduling, premium comfort, and experienced chauffeurs dedicated to providing a seamless travel experience for your round-trip needs."
  },
  {
    "name": "AC Innova Crysta Taxi Mumbai Airport to Pune",
    "description": "Beat the heat with our fully air-conditioned Innova Crysta taxi from Mumbai Airport to Pune. With plush interiors and climate control, this service ensures a refreshing and comfortable journey no matter the season."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Mumbai Airport Pune",
    "description": "Sit back and relax as our professional chauffeurs drive you from Mumbai Airport to Pune in a top-quality Innova Crysta. We prioritize safety, punctuality, and courteous service for a stress-free airport transfer."
  },
  {
    "name": "Private Innova Crysta Mumbai Airport to Pune",
    "description": "Enjoy exclusive travel with our private Innova Crysta cab service from Mumbai Airport to Pune. Ideal for VIPs and travelers seeking privacy, this service provides dedicated vehicles and personalized attention for a comfortable ride."
  },
  {
    "name": "Online Mumbai Airport to Pune Innova Crysta Booking",
    "description": "Book your Mumbai Airport to Pune Innova Crysta taxi online with ease. Our secure and user-friendly platform offers instant confirmations, flexible timings, and transparent pricing to fit your schedule and budget."
  },
  {
    "name": "Family Innova Crysta Cab Mumbai Airport to Pune",
    "description": "Travel comfortably with your family from Mumbai Airport to Pune in our spacious Innova Crysta cab. With ample legroom and luggage space, this service ensures a smooth, safe, and enjoyable journey for all family members."
  }
],
"tableData": [
  ["Mumbai Airport to Pune Innova Crysta Cab Booking", "One Way Innova Crysta Mumbai Airport to Pune"],
  ["Round Trip Mumbai Airport Pune Innova Crysta", "AC Innova Crysta Taxi Mumbai Airport to Pune"],
  ["Chauffeur Driven Innova Crysta Mumbai Airport Pune", "Private Innova Crysta Mumbai Airport to Pune"],
  ["Online Mumbai Airport to Pune Innova Crysta Booking", "Family Innova Crysta Cab Mumbai Airport to Pune"]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cabs from Mumbai Airport to Pune",
        "WhyChoosedescription": "Book a reliable and luxurious Innova Crysta for your journey from Mumbai Airport to Pune. Perfect for families, business travelers, and groups, our service ensures a smooth and stress-free transfer with top-tier comfort."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Travel Experience",
        "WhyChoosedescription": "Our Innova Crysta cabs offer generous legroom, plush seating, and plenty of luggage space, comfortably accommodating 6–7 passengers. It’s the perfect choice for a long-distance trip after a flight."
    },
    {
        "WhyChooseheading": "Timely Airport Pickup with Flight Monitoring",
        "WhyChoosedescription": "We track your flight in real time to ensure timely pickup, even in case of delays. Our driver will be ready at the terminal to assist you with your luggage and ensure a quick, smooth departure from the airport."
    },
    {
        "WhyChooseheading": "Professional Drivers with Long-Distance Experience",
        "WhyChoosedescription": "Our trained drivers are courteous and experienced in handling airport pickups and outstation routes. They choose the safest, fastest routes from Mumbai Airport to Pune, ensuring punctual and relaxed travel."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Each Innova Crysta is thoroughly cleaned, sanitized, and checked for performance before every ride. You can expect a hygienic, well-maintained cab for a safe journey."
    },
    {
        "WhyChooseheading": "Transparent and Fixed Pricing",
        "WhyChoosedescription": "No surge pricing or hidden charges. Our fares include tolls, taxes, fuel, and driver allowances—so you get full transparency and great value for your money."
    },
    {
        "WhyChooseheading": "24/7 Service and Support for Airport Transfers",
        "WhyChoosedescription": "Whether you land early morning or late at night, we’re available round the clock. Our customer service team is always ready to help with bookings, updates, or last-minute changes."
    },
    {
        "WhyChooseheading": "Perfect for Business Travel, Families, and Groups",
        "WhyChoosedescription": "Whether you’re heading to Pune for a meeting, a wedding, or a family trip, our Innova Crysta cabs provide the right mix of comfort, space, and professionalism to meet every need."
    }
]





















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Mumbai Airport to Pune?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and reliable booking."
    },
    {
        question: "Is the Innova Crysta available for pickup from both Mumbai Airport terminals?",
        answer: "Yes, we provide pickups from both Terminal 1 (Domestic) and Terminal 2 (International) of Mumbai Airport."
    },
    {
        question: "How long does it take to travel from Mumbai Airport to Pune in an Innova Crysta?",
        answer: "The journey takes approximately 3.5 to 4.5 hours, depending on traffic and road conditions."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, we track your flight and adjust the pickup time accordingly. Waiting charges may apply after a certain grace period."
    },
    {
        question: "Is the Innova Crysta comfortable for airport transfers with luggage?",
        answer: "Absolutely. Innova Crysta offers spacious seating for 6–7 passengers and ample luggage space."
    },
    {
        question: "Is the cab service available 24/7 from Mumbai Airport to Pune?",
        answer: "Yes, we offer round-the-clock Innova Crysta cab service to and from Mumbai Airport."
    },
    {
        question: "Are the vehicles sanitized before each ride?",
        answer: "Yes, all our cabs are cleaned and sanitized before every trip to ensure passenger safety."
    },
    {
        question: "What is included in the fare for this service?",
        answer: "The fare includes driver charges, fuel, and tolls. Parking or extended waiting charges may be additional."
    },
    {
        question: "How do I locate my driver at Mumbai Airport?",
        answer: "Your driver will contact you upon arrival and may display a placard with your name at the arrival gate if requested."
    },
    {
        question: "What payment methods are accepted for the ride?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Vinay Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Mumbai Airport to Pune for my family. Smooth ride, spacious cab, and on-time pickup!”',
    },
    {
        name: 'Ms. Rupal Thakkar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service by Meghana Cab. The driver was professional and the Innova Crysta was clean and comfortable.”',
    },
];











































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const mumbaiAirportToPuneInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Mumbai Airport to Pune Innova Crysta Cab Service",
  "description": "Premium chauffeur-driven Innova Crysta taxi service from Mumbai Airport to Pune. Perfect for one-way, round trip, family travel, and corporate rides. Affordable and reliable cab hire with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Airport Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/mumbai-airport-to-pune-innova-crysta-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>Mumbai Airport to Pune Innova Crysta Cab | Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs from Mumbai Airport to Pune for family, corporate, and one-way trips. Reliable and affordable airport taxi service."
  />
  <meta
    name="keywords"
    content="Mumbai Airport to Pune Innova Crysta Cab Booking, One Way Innova Crysta Mumbai Airport to Pune, Round Trip Mumbai Airport Pune Innova Crysta, AC Innova Crysta Taxi Mumbai Airport to Pune, Chauffeur Driven Innova Crysta Mumbai Airport Pune, Private Innova Crysta Mumbai Airport to Pune, Online Mumbai Airport to Pune Innova Crysta Booking, Family Innova Crysta Cab Mumbai Airport to Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportToPuneInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopuneinnovacrystacabs;